import React from "react";
import { useTheme } from "styled-components";

const ImageSlider = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.188 3.375H5.063a.563.563 0 0 0-.563.563v7.874c0 .311.252.563.563.563h10.125c.31 0 .562-.252.562-.562V3.936a.56.56 0 0 0-.562-.562"
        stroke={theme.text.text}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.094 6.61a.703.703 0 1 0 0-1.407.703.703 0 0 0 0 1.406"
        fill={theme.text.text}
      />
      <path
        d="m4.5 9.049 2.696-2.697a.563.563 0 0 1 .796 0l3.49 3.492L13.29 8.04a.56.56 0 0 1 .795 0l1.666 1.667"
        stroke={theme.text.text}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 12.375v1.688a.56.56 0 0 1-.562.562H2.813a.563.563 0 0 1-.563-.562V6.187a.563.563 0 0 1 .563-.562H4.5"
        stroke={theme.text.text}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ImageSlider;
